var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2 d-flex justify-content-end"},[_c('CorrectiveActionPopover',{attrs:{"event-id":_vm.eventId}},[_c('div',{staticClass:"wand"},[_c('i',{staticClass:"icon-corrective-action"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }